import { motion } from 'motion/react';
import { pageTransition } from '@/lib/motion/variants';
import { PageMeta } from '@/components/shared/PageMeta';
import { Hero } from '@/features/home/components/Hero';
import { ServicesStrip } from '@/features/home/components/ServicesStrip';
import { AdventureManifesto } from '@/features/home/components/AdventureManifesto';
import { ThreeScenes } from '@/features/home/components/ThreeScenes';
import { StaysGrid } from '@/features/home/components/StaysGrid';
import { HouseboatsGrid } from '@/features/home/components/HouseboatsGrid';
import { GuidesGrid } from '@/features/home/components/GuidesGrid';
import { KashmirMap } from '@/features/home/components/KashmirMap';
import { ValleyPulse } from '@/features/home/components/ValleyPulse';
import { RewardsCompanions } from '@/features/home/components/RewardsCompanions';
import { TrailConnectPromo } from '@/features/home/components/TrailConnectPromo';
import { TrailKitPreview } from '@/features/home/components/TrailKitPreview';
import { TrustBar } from '@/features/home/components/TrustBar';

/**
 * HomePage section rhythm — alternates card grids with editorial / interactive
 * pieces so no two consecutive sections share a layout. The Adventure manifesto
 * runs second (right after Services) because the brand promise sets up everything
 * that follows.
 */
export function HomePage() {
  return (
    <motion.div variants={pageTransition} initial="initial" animate="animate" exit="exit">
      <PageMeta
        title="Uncharted Odyssey — Kashmir, curated"
        description="The only marketplace for every trek, ski run, houseboat, ride, and licensed local guide in Kashmir. Show up. Match. Travel together."
        image="photo-1506905925346-21bda4d32df4"
      />
      <Hero />
      <ServicesStrip />
      <AdventureManifesto />
      <ThreeScenes />
      <KashmirMap />
      <StaysGrid />
      <ValleyPulse />
      <HouseboatsGrid />
      <TrailConnectPromo />
      <RewardsCompanions />
      <TrailKitPreview />
      <GuidesGrid />
      <TrustBar />
      <div className="h-12" />
    </motion.div>
  );
}
